import { useQuery } from "@tanstack/react-query";
import {
  type GetStardustLeaderboardQueryResult,
  type LoyaltyPointType,
  getLoyaltiesLeaderboard,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const LOYALTIES_LEADERBOARD_QUERY_KEY = "LOYALTIES_LEADERBOARD";

export const loyaltiesLeaderboardKeys = {
  all: [LOYALTIES_LEADERBOARD_QUERY_KEY],
  byParams: (
    limit?: number,
    offset?: number,
    pointType?: LoyaltyPointType,
    settlementPeriodId?: number,
  ) => [
    ...loyaltiesLeaderboardKeys.all,
    limit,
    offset,
    pointType,
    settlementPeriodId,
  ],
};

type Props = {
  limit?: number;
  offset?: number;
  pointType?: LoyaltyPointType;
  settlementPeriodId?: number;
  enabled?: boolean;
};

export const useLoyaltiesLeaderboardQuery = ({
  limit,
  offset,
  pointType,
  settlementPeriodId,
  enabled = true,
}: Props = {}) =>
  useQuery<GetStardustLeaderboardQueryResult>({
    queryKey: loyaltiesLeaderboardKeys.byParams(
      limit,
      offset,
      pointType,
      settlementPeriodId,
    ),
    queryFn: processResponseWithApiProblemDetails(() =>
      getLoyaltiesLeaderboard(limit, offset, pointType, settlementPeriodId),
    ),
    enabled,
  });
